import { PrivacyLayout } from "@features/layout";

export const PrivacyPage = () => {
  return <PrivacyLayout />;
};
